import { render, staticRenderFns } from "./OutsideReceipt.vue?vue&type=template&id=67386b6f&scoped=true"
import script from "./OutsideReceipt.vue?vue&type=script&lang=js"
export * from "./OutsideReceipt.vue?vue&type=script&lang=js"
import style0 from "./OutsideReceipt.vue?vue&type=style&index=0&id=67386b6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67386b6f",
  null
  
)

export default component.exports